(function () {
  function initialiseNamePersonalisation(root) {
    root = root || document;

    const boxes = root.querySelectorAll(
      '.kk-name-personalisation-box'
    );

    boxes.forEach(function (box) {
      if (box.dataset.kkInitialised === 'true') {
        return;
      }

      const sectionId = box.dataset.sectionId;

      if (!sectionId) {
        return;
      }

      const input = box.querySelector(
        '.kk-personalisation-input'
      );

      if (!input) {
        return;
      }

      const section =
        document.getElementById(
          'MainProduct-' + sectionId
        ) || box.closest('.shopify-section');

      if (!section) {
        return;
      }

      box.dataset.kkInitialised = 'true';

      function isWithNameSelected() {
        let selected = false;

        section
          .querySelectorAll(
            'input[type="radio"][value="With Name"]'
          )
          .forEach(function (radio) {
            if (radio.checked) {
              selected = true;
            }
          });

        section
          .querySelectorAll('select')
          .forEach(function (select) {
            if (select.value === 'With Name') {
              selected = true;
            }
          });

        return selected;
      }

      function updateNameField() {
        if (isWithNameSelected()) {
          box.style.display = 'block';
          input.disabled = false;
          input.required = true;
        } else {
          box.style.display = 'none';
          input.disabled = true;
          input.required = false;
          input.value = '';
          input.setCustomValidity('');
        }
      }

      section.addEventListener(
        'change',
        function (event) {
          if (
            event.target.matches(
              'input[type="radio"]'
            ) ||
            event.target.matches('select')
          ) {
            updateNameField();
          }
        }
      );

      section.addEventListener(
        'click',
        function (event) {
          const addButton = event.target.closest(
            'button[name="add"], product-form button[type="submit"]'
          );

          if (!addButton) {
            return;
          }

          if (!isWithNameSelected()) {
            return;
          }

          if (input.value.trim() === '') {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            input.setCustomValidity(
              'Please enter a name.'
            );

            input.reportValidity();
            input.focus();

            return false;
          }

          input.setCustomValidity('');
        },
        true
      );

      input.addEventListener(
        'input',
        function () {
          input.setCustomValidity('');
        }
      );

      updateNameField();
    });
  }

  function initialise() {
    initialiseNamePersonalisation(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialise,
      { once: true }
    );
  } else {
    initialise();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initialiseNamePersonalisation(
        event.target
      );
    }
  );
})();